import React from 'react';
import { sanitizeHtml } from '../../utils/blog';

const PostContent = ({ html }) => (
  <div
    className="prose prose-invert max-w-none"
    dangerouslySetInnerHTML={{ __html: sanitizeHtml(html) }}
  />
);

export default PostContent;
